<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-toolbar class="custom-toolbar">
  <ion-searchbar
    #busStationSearch
    mode="ios"
    placeholder="{{
      'Search by City' | translate
    }}"
    (keyup.enter)="filterBusStationListOnEnter($event)"
    (ionInput)="filterBusStationList($event)"
  >
  </ion-searchbar>
</ion-toolbar>

<ion-content>
  <ion-grid
    *ngIf="noData && page === 1; else showAirportList"
    class="ion-text-center v-center"
  >
    <ion-row>
      <ion-col size="12">
        <ion-label class="fs-3 font500 text-color">{{
          "bus.bus_search.bus_station_not_available" | translate
        }}</ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-template #showAirportList>
    <ion-list class="ion-list-transparent-bg-color">
      <ion-item
        lines="full"
        class="ion-justify-content-start ion-no-padding ion-item-transparent-bg-color"
        *ngFor="let busStation of busStationList"
        (click)="selectBusStation(busStation)"
      >
      
       <ion-icon
              slot="start"
              name="location-outline"
              class="primary-icon-color ion-margin-end"
            ></ion-icon>
        <ion-label *ngIf="busStation">
          <p class="fs-3 font500 airport_name airport-container paragraph-primary-text-color line-1-clip">
            {{ busStation?.airportName }}
          </p>
          <div class="d-flex ion-justify-content-between">
            <p
              class="fs-3 font500 airport_city paragraph-secondary-text-color ion-no-margin"
            >
              {{ busStation?.city }} , {{ busStation?.state }}
            </p>
            <ion-chip
              class="primary-chip fs-3 chip-height"
              *ngIf="busStation?.tag"
            >
              {{ busStation?.tag }}
            </ion-chip>
          </div>
        </ion-label>
      </ion-item>
    </ion-list>

    <div *ngIf="busStationList?.length <= 0 && noData === 0 && !hasError">
      <ion-list class="ion-list-transparent-bg-color">
        <ion-item
          *ngFor="let item of [0, 1, 2, 3, 4, 5, 6, 7]"
          class="ion-item-transparent-bg-color"
        >
          <ion-label>
            <h3>
              <ion-skeleton-text
                animated
                style="width: 80%; height: 16px"
              ></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text
                animated
                style="width: 50%"
              ></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </ng-template>

  <!-- <app-inline-generic-error *ngIf="hasError"></app-inline-generic-error> -->

  <ion-infinite-scroll (ionInfinite)="getNextPage($event)" *ngIf="!hasError" >
    <ion-infinite-scroll-content> </ion-infinite-scroll-content>
  </ion-infinite-scroll>

</ion-content>
